import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';

import './i18n';

const container = document.getElementById('root');

const anwendung = (
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);

// Liegt vorgerendertes Markup vor, wird es uebernommen statt weggeworfen.
// Der Marker kommt aus scripts/prerender.js.
if (document.documentElement.dataset.prerendered === 'true') {
    ReactDOM.hydrateRoot(container, anwendung);
} else {
    ReactDOM.createRoot(container).render(anwendung);
}

reportWebVitals();
